import React from 'react';
import { Ico } from './ui/Ico';

/**
 * ErrorBoundary global — um erro de renderização em qualquer componente
 * não derruba mais o app inteiro em tela branca.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[LevNutri] Erro de renderização:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', padding: '2rem',
          textAlign: 'center', fontFamily: 'inherit',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}><Ico e="😕" /></div>
          <h2 style={{ margin: '0 0 0.5rem', color: '#2f2a26' }}>Algo deu errado nesta tela</h2>
          <p style={{ margin: '0 0 1.25rem', color: '#736b64', maxWidth: 420 }}>
            O restante do sistema continua funcionando. Você pode tentar recarregar
            ou voltar para o Dashboard.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '0.6rem 1.2rem', borderRadius: 8, border: 'none',
                       background: '#D4A574', color: '#ffffff', fontWeight: 600, cursor: 'pointer' }}
            >
              Recarregar
            </button>
            <button
              onClick={() => { window.location.href = '/app/dashboard'; }}
              style={{ padding: '0.6rem 1.2rem', borderRadius: 8,
                       border: '1px solid #D4A574', background: 'transparent',
                       color: '#D4A574', fontWeight: 600, cursor: 'pointer' }}
            >
              Ir para o Dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
